// Api end points
export const userAdd = '/v1/add-user';
export const userUpdate = '/v1/update-user';
export const customerServiceAdd = '/v1/add-customer-service';
export const contactAdvisorAdd = '/v1/contact-advisor';
export const careerAdd = '/v1/add-career';
export const employerAdd = '/v1/add-employer';
export const ownerDetail = '/v1/get-user-by-id';
export const agentAdd = '/v1/add-agent-interest';
export const loginAdd = '/v1/login-user';
export const listData = '/v1/get-user-list';
export const statusChangeApi = '/v1/update-agent-status';
export const generatePaymentToken = '/v1/generate-payment-token';
export const paymentDeduct = '/v1/deduct-payment';
export const initialPayment = '/v1/initiate-payment';
export const passwordforgot = '/v1/forgot-password';
export const validMember = '/v1/check-agent-url';
export const SurityCareList = '/v1/get-surity-care-list';
export const StrategizerList = '/v1/get-strategizer-list';
export const helpAdd = '/v1/send-agent-help-mail';
export const realtorGroupListData = '/v1/get_realtor_group_list';
export const addRealtorGrp = '/v1/add_realtor_group';

export const SRealtorGroup = '/v1/search_realtor_group';
export const mortgageInsuranceForm = '/v1/mortgage-insurance-form';
export const unsubscribeServiceApi = '/v1/add-unsubscribe';
export const unSubcribe = '/v1/payment-unsubscribe';

export const getProduct = '/v1/get-all-product';

export const getProductUrl = '/v1/get-product-url';

export const updateProductUrl = '/v1/add-product-url';

export const getSingleProductUrl = '/v1/get-single-product-url';

export const getRealtorGroupUserList = '/v1/get_realtor_user_list';

export const getEductionGroupStateList = '/v1/get-group-state';

export const getEductionGroupCountyList = '/v1/get-group-county';

export const deleteUserUrl = '/v1/delete-member';

export const exportMember = '/v1/export-member';

export const getUserByCode = '/v1/get-user-by-membercode';

export const eventDetail = '/v1/event-code';

export const strateQuestion = '/v1/strategizer/getAll';

export const strateSaveAns = '/v1/save-strategizer-answer';

export const stripeDetail = '/v1/create-stripe-checkout';

export const upgradeStripePlan = '/v1/upgraded-stripe-plan';

export const upgradeAuthPlan = '/v1/auth-upgrade-plan';

export const getPlanList = '/v1/get-plan-list';

export const getUpgradePlans = '/v1/get-upgrade-plans';

export const initiateUpgradePlan = '/v1/initiate-upgrade-plan';

export const cancelForUpgradePlan = '/v1/cancel-plan-for-upgrade';

export const FundRaiserReport = '/v1/fundraiser-report';

// Authorize.Net config — values come from REACT_APP_API_LOGIN_ID / REACT_APP_CLIENT_KEY.
// Empty-string fallback so missing vars don't crash the app at startup; payment
// flows will fail gracefully at runtime if the vars are absent.
export const apiloginid = process.env.REACT_APP_API_LOGIN_ID || '';
export const clientkey = process.env.REACT_APP_CLIENT_KEY || '';

if (process.env.NODE_ENV !== 'production' && (!apiloginid || !clientkey)) {
  console.warn(
    '[config] Payment env vars missing: REACT_APP_API_LOGIN_ID and/or REACT_APP_CLIENT_KEY. ' +
      'Add them to .env or .env.development.local.'
  );
}

export const authorizeLink =
  typeof window !== 'undefined' && window.location.hostname === 'surityselect.com'
    ? 'https://js.authorize.net/v3/AcceptUI.js?v=2.0.3'
    : 'https://jstest.authorize.net/v3/AcceptUI.js?v=2.0.3';

export const deductAmount = 12.75;
export const agentEssentialDeductAmount = 12.95;
export const agentProfessionalDeductAmount = 15.95;

// sesstion key
export const sessionId = 'surity-memberData';
export const loginId = 'surity-loginData';
export const userSessionId = 'surity-access-token';
export const userSessionRefreshed = 'surity-refresh-token';
// export const userSessionId = 'surity-userid';

//pagination

export const iterPerpage = 10;
